import { ApplicationStatus } from '@features/applications';

export const getHiringStatusButtonColor = (status: ApplicationStatus) => {
  switch (status) {
    case 'unattended':
      return 'yellow';
    case 'messaged':
      return 'primary';
    case 'saved':
      return 'green';
    case 'interview process':
      return 'secondary';
    case 'pending job offers':
      return 'lightPurple';
    case 'hired':
    case 'Onboarding Pending':
      return 'purple';
    case 'declined':
      return 'error';
    case 'archived':
      return 'dark';
    case 'attended':
      return 'success';
    default:
      return 'yellow';
  }
};
